import { Button } from 'components';
import styles from './NotFoundPage.module.scss';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div>
                <h3 className={styles.header}>Not Found</h3>
            </div>
            <div>
                <h4 className={styles.info}>
                    Sorry, the page or resource you have requested is not found.
                </h4>
            </div>
            <div className={styles.button}>
                <Button themeColor="primary" onClick={() => navigate('/')}>
                    Return Home
                </Button>
            </div>
        </div>
    );
};